<template>
  <div class="w-full flex flex-row">
    <div class="flex flex-col w-1/2">
      <!-- button_type -->
      <div class="flex flex-col w-1/2 mb-6">
        <label class="font-semibold text-sm text-grey-700 mb-2">
          {{ $t('frontend_bumps_button_type') }}
        </label>
        <gd-dropdown
          v-model="localModel.customization_details.embed_button.button_type"
          :options="buttonTypeOptions"
          :placeholder="$t('frontend_bumps_button_type')"
        />
      </div>

      <div
        class="flex flex-col w-1/2 mb-6"
        v-if="localModel.customization_details.embed_button.button_type == 1"
      >
        <label class="font-semibold text-sm text-grey-700 mb-2">
          {{ $t('frontend_bumps_button_before_text') }}
        </label>
        <text-input
          v-model="localModel.customization_details.embed_button.button_before_text"
          :attribute="$t('frontend_button_text')"
          :value="localModel.customization_details.embed_button.button_before_text"
          :placeholder="$t('frontend_bumps_button_before_text')"
        />
      </div>

      <div class="flex flex-row w-1/2 mb-6">
        <div class="flex flex-col w-1/2">
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{ $t('frontend_bumps_button_bg_color') }}
          </label>
          <div class="pr-6 w-24">
            <color-picker
              v-model="localModel.customization_details.embed_button.button_before_bg_color"
              class="border-2 border-grey-300 rounded"
              :colors="colors"
              :cookies-origin="'groovesell_funnel_' + localModel.funnel_id"
            ></color-picker>
          </div>
        </div>

        <div
          class="flex flex-col w-1/2 ml-2"
          v-if="localModel.customization_details.embed_button.button_type == 1"
        >
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{ $t('frontend_bumps_button_font_color') }}
          </label>
          <div class="pr-6 w-24">
            <color-picker
              v-model="localModel.customization_details.embed_button.button_before_font_color"
              class="border-2 border-grey-300 rounded"
              :colors="colors"
              :cookies-origin="'groovesell_funnel_' + localModel.funnel_id"
            ></color-picker>
          </div>
        </div>
      </div>

      <div class="flex flex-row w-1/2 mb-6">
        <!-- button_before_border_size -->
        <div class="flex flex-col w-1/2">
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{ $t('frontend_bumps_button_border_size') }}
          </label>
          <gd-dropdown
            v-model="localModel.customization_details.embed_button.button_before_border_size"
            :options="borderSizeOptions"
          />
        </div>

        <!-- button_before_border_color -->
        <div
          class="flex flex-col w-1/2 ml-2"
          v-if="localModel.customization_details.embed_button.button_type == 1"
        >
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{ $t('frontend_bumps_button_border_color') }}
          </label>
          <div class="pr-6 w-24">
            <color-picker
              v-model="localModel.customization_details.embed_button.button_before_border_color"
              class="border-2 border-grey-300 rounded"
              :colors="colors"
              :cookies-origin="'groovesell_funnel_' + localModel.funnel_id"
            ></color-picker>
          </div>
        </div>
      </div>

      <!-- button_size -->
      <div class="flex flex-col w-1/2 mb-6">
        <label class="font-semibold text-sm text-grey-700 mb-2">
          {{ $t('frontend_bumps_button_size') }}
        </label>
        <gd-dropdown
          v-model="localModel.customization_details.embed_button.button_size"
          :options="buttonSizeOptions"
        />
      </div>

      <!-- button shape -->
      <div
        class="flex flex-col w-1/2 mb-6"
        v-if="localModel.customization_details.embed_button.button_type == 1"
      >
        <label class="font-semibold text-sm text-grey-700 mb-2">
          {{ $t('frontend_bumps_button_shape') }}
        </label>
        <gd-dropdown
          v-model="localModel.customization_details.embed_button.button_shape"
          :options="buttonShapeOptions"
        />
      </div>

      <!-- frontend_bumps_button_shadow -->
      <div class="flex flex-col w-1/2 mb-6">
        <label class="font-semibold text-sm text-grey-700 mb-2">
          {{ $t('frontend_bumps_button_shadow') }}
        </label>
        <gd-dropdown
          v-model="localModel.customization_details.embed_button.button_shadow"
          :options="buttonShadowOptions"
        />
      </div>
    </div>

    <!-- {{customColor}} -->
    <div
      class="w-1/2 flex flex-col justify-center items-center px-8"
      :style="[customColor]"
    >
      <gd-button
        v-if="localModel.customization_details.embed_button.button_type == 1"
        variant="primary"
        :size="embedButtonSize"
        class="custom-embed-before-button-color font-bold"
        :class="{
          'rounded-full': localModel.customization_details.embed_button.button_shape == 2,
          'w-32 py-6': localModel.customization_details.embed_button.button_size == 1,
          'w-64 py-6 text-lg': localModel.customization_details.embed_button.button_size == 2,
          'w-18 text-xs': localModel.customization_details.embed_button.button_size == 3,
          'shadow-sm': localModel.customization_details.embed_button.button_shadow == 1,
          'shadow': localModel.customization_details.embed_button.button_shadow == 2,
          'shadow-lg': localModel.customization_details.embed_button.button_shadow == 3,
          'shadow-xl': localModel.customization_details.embed_button.button_shadow == 4,
          'border-2': localModel.customization_details.embed_button.button_before_border_size == 1,
          'border-none': localModel.customization_details.embed_button.button_before_border_size == 2,
          'border': localModel.customization_details.embed_button.button_before_border_size == 3,
          'border-4': localModel.customization_details.embed_button.button_before_border_size == 4,
        }"
        :key="buttonSizeKey"
      >
        <em class="fas fa-plus-circle mr-1"></em>
        {{ localModel.customization_details.embed_button.button_before_text }}
      </gd-button>

      <gd-toggle
        v-else
        class="custom-embed-toggle-color"
        v-model="embedToggleValue"
      >
      </gd-toggle>
    </div>
  </div>
</template>

<script>
import ColorPicker from '@groovepages/gd-ui-kit/components/ColorPicker';

export default {
  components: {
    ColorPicker,
  },
  props: {
    model: {
      required: true,
    },
    colors: {
      required: true,
    },
    customColor: {
      required: true,
    },
    embedButtonSize: {
      required: true,
    },
    buttonSizeKey: {
      required: true,
    },
  },
  data() {
    return {
      localModel: this.model,
      embedToggleValue: true,
    }
  },
  computed: {
    buttonTypeOptions() {
      return [
        { value: 1, text: this.$t('frontend_button') },
        { value: 2, text: this.$t('frontend_toggle') },
      ];
    },
    borderSizeOptions() {
      return [
        { value: 1, text: this.$t('frontend_groovesell_bumps_step4_regular') },
        { value: 2, text: this.$t('frontend_groovesell_bumps_step4_none') },
        { value: 3, text: this.$t('frontend_groovesell_bumps_step4_small') },
        { value: 4, text: this.$t('frontend_groovesell_bumps_step4_large') },
      ];
    },
    buttonSizeOptions() {
      return [
        { value: 1, text: this.$t('frontend_groovesell_bumps_step4_small') },
        { value: 2, text: this.$t('frontend_groovesell_bumps_step4_medium') },
        { value: 3, text: this.$t('frontend_groovesell_bumps_step4_large') },
      ];
    },
    buttonShapeOptions() {
      return [
        { value: 1, text: this.$t('frontend_groovesell_bumps_step4_regular') },
        { value: 2, text: this.$t('frontend_groovesell_bumps_step4_rounded') },
      ];
    },
    buttonShadowOptions() {
      return [
        { value: 1, text: this.$t('frontend_groovesell_bumps_step4_small') },
        { value: 2, text: this.$t('frontend_groovesell_bumps_step4_medium') },
        { value: 3, text: this.$t('frontend_groovesell_bumps_step4_large') },
        { value: 4, text: this.$t('frontend_groovesell_bumps_step4_xlarge') },
      ];
    },
  },
}
</script>
